export const CONVERSION_MODE = "waitlist";

/** Afficher la section « Notre histoire » (fondatrice). Mettre REACT_APP_SHOW_FOUNDER_SECTION=false pour la masquer. */
export const SHOW_FOUNDER_SECTION =
  process.env.REACT_APP_SHOW_FOUNDER_SECTION !== "false";

/** Afficher la section tarifs / offres entreprise. Mettre REACT_APP_SHOW_PRICING_SECTION=true quand les forfaits sont prêts. */
export const SHOW_PRICING_SECTION =
  process.env.REACT_APP_SHOW_PRICING_SECTION === "true";

export const STORE_LINKS = {
  ios: "",
  android: "",
};

export const CONTACT_EMAIL = "contact@crushemploi.com";

export const SITE_URL = "https://crushemploi.com";

/** Chemins des assets statiques (`public/images/`). */
export const IMAGES = {
  brand: {
    logo: "/images/brand/crush_emploi_logo.jpg",
    ogShare: "/images/brand/og-share.svg",
  },
  heroes: {
    candidat: "/images/heroes/candidat-hero.svg",
    entreprise: "/images/heroes/recruteur-hero.png",
    appMockup: "/images/heroes/placeholder-app-mockup.svg",
    placeholderCandidat: "/images/heroes/placeholder-candidat.svg",
    placeholderEntreprise: "/images/heroes/placeholder-entreprise.svg",
  },
  sections: {
    genZ: "/images/sections/gen-z.svg",
    femmePhone: "/images/sections/femme-phone.svg",
    hommeRecruiter: "/images/sections/homme_recruiter.png",
    selma: "/images/sections/selma.jpg",
  },
  photos: {
    routerCandidat: "/images/photos/candidat.png",
    routerEntreprise: "/images/photos/recruteur.jpg",
    founder: "/images/photos/selma_crush_emploi.jpg",
    candidatBureau: "/images/photos/candidat_bureau.jpg",
  },
};

export const BRAND = {
  name: "Crush Emploi",
  logo: IMAGES.brand.logo,
  logoAlt: "Crush Emploi",
};

/** @deprecated Préférer `IMAGES` — conservé pour compatibilité. */
export const PLACEHOLDER_IMAGES = {
  candidat: IMAGES.heroes.placeholderCandidat,
  entreprise: IMAGES.heroes.placeholderEntreprise,
  appMockup: IMAGES.heroes.appMockup,
  ogShare: IMAGES.brand.ogShare,
  genZ: IMAGES.sections.genZ,
};

export const WHY_CONTEXT_IMAGE = {
  src: IMAGES.sections.genZ,
  alt: "Illustration Gen Z et réseaux sociaux",
};

export const OG_DEFAULT_IMAGE = IMAGES.brand.ogShare;
export const OG_IMAGE_ALT =
  "Crush Emploi — Recrutement vidéo et crush mutuel pour la Gen Z";

export const SOCIAL_LINKS = {
  tiktok: "https://www.tiktok.com/@crush.emploi",
  instagram: "https://www.instagram.com/crush_emploi_/",
  linkedin: "",
};

export const GA_MEASUREMENT_ID =
  process.env.REACT_APP_GA_MEASUREMENT_ID || "";
